import { IApplicationState, TRegionSearchCitiesState } from '../../types/redux';

export const selectRegionSearchCities = (state: IApplicationState): TRegionSearchCitiesState => {
  const { regionSearchCities } = state.temp;

  return regionSearchCities && regionSearchCities.length ? regionSearchCities.slice(0, 4) : [];
};
